// @flow

export const yellow = '#FFDE91'
export const yellow60 = '#ffebbd'
export const yellow80 = '#FFE4A7'
export const pink = '#E57CD8'
export const pink10 = '#F7D8F3'
export const pink30 = '#f7d8f3'
export const pink40 = '#f2bdec'
export const pink70 = '#EDA3E4'
export const pink80 = '#EA96E0'
export const beige = '#FCE5D8'
export const beigeDark = '#FFB8AF'
export const peach = '#FDECE5'
export const peach10 = '#fce5db'
export const peach50 = '#fdf1ec'
export const lightBeige = '#FDF1EC'
export const almostWhite = '#FFF3ED'
export const white = '#FFF'
export const darkPurple = '#2C1338'
export const darkPurple70 = '#6B5A74'
export const fadedPurple = '#412A4C'
export const fadedPurpleAlt = '#564260'
export const purple60 = '#817187'
export const darkPurple40 = '#ABA0AF'
export const darkPurple20 = '#D5D0D7'
export const lightPurple = '#ABA0AF'
export const dawnPink = '#F3E8E2'
export const almond = '#F0D7CD'
export const violet = '#A876F5'
export const violet60 = '#CBADF9'
export const orange = '#FF8A7A'
export const orange10 = '#FFF3F2'
export const orange60 = '#FFB8AF'
export const red = '#f66c6c'
export const lightPink = '#FAE5F7'
export const green = '#4BC800'
export const pink50 = '#F5CBEF'
export const lightGray = '#D5D0D7'
export const darkGray = '#95899B'
export const black = '#000000'
export const gold = '#ac7501'
